import React, { useCallback } from 'react';

import { useCadastroDecomposicao } from '../CadastroDeDecomposicaoContext';
import { TipoDecomposicao } from '../types';
import { InputSelect } from '~/components/NovosInputs';

type SelectProps = {
  label: string;
  value: number;
};

const options: SelectProps[] = [
  { label: 'Fracionado', value: TipoDecomposicao.FRACIONADO },
  { label: 'Unitário', value: TipoDecomposicao.UNITARIO },
];

export const SelectTipoDecomposicao: React.FC = () => {
  const {
    formData,
    setFormData,
    reset,
    setUpdateItems,
    getValues,
    setValue,
    control,
    register,
    decomposicaoUnitaria,
    decomposicaoFracionada,
  } = useCadastroDecomposicao();

  const handleSelectChange = useCallback(
    (selectedOption) => {
      if (selectedOption) {
        const selectedValue = +selectedOption.value;

        setFormData({
          ...formData,
          tipo_forma_explosao: {
            value: selectedValue,
            isInvalid: false,
            isRequired: false,
          },
        });
        const decomposicaoVal = getValues('decomposicaoVal');
        reset();
        setValue('decomposicaoVal', decomposicaoVal);
        setValue('produtoBusca', { value: undefined, label: '' });
        setValue('tipo_decomposicao', selectedOption);
        setUpdateItems(false);
      }
    },
    [setFormData, formData],
  );

  const disabledTipo = () => {
    if (decomposicaoUnitaria.length > 0) return true;
    if (decomposicaoFracionada.length > 0) return true;

    return false;
  };

  return (
    <InputSelect
      placeholder="Selecione um tipo"
      label="Tipo"
      name="tipo_decomposicao"
      options={options}
      changeSelected={handleSelectChange}
      isDisabled={disabledTipo()}
      control={control}
      register={register}
      isError={false}
    />
  );
};
